import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { AUTH_ROUTE_PATH } from '../models/auth-user.model';
import { SESSION_FAILURE, SESSION_STATUS, SessionLoadResult } from '../models/session.model';
import { AuthStateService } from '../services/auth-state.service';
import { SessionControllerService } from '../services/session-controller.service';

export const sessionGuard: CanMatchFn = () => {
  const controller = inject(SessionControllerService);
  const auth = inject(AuthStateService);
  const router = inject(Router);

  return controller.loadSession().pipe(
    map((result: SessionLoadResult) => {
      if (result.failure === SESSION_FAILURE.UNAUTHORIZED) {
        auth.signOut();
        return router.createUrlTree([AUTH_ROUTE_PATH.LOGIN]);
      }

      if (result.failure === SESSION_FAILURE.BLOCKED) {
        return router.createUrlTree([AUTH_ROUTE_PATH.NO_ACCESS]);
      }

      if (result.failure) return true;

      if (result.session?.status === SESSION_STATUS.BLOCKED) {
        return router.createUrlTree([AUTH_ROUTE_PATH.NO_ACCESS]);
      }

      if (result.session?.status === SESSION_STATUS.NO_ROLE) {
        auth.signOut();
        return router.createUrlTree([AUTH_ROUTE_PATH.LOGIN]);
      }

      if (result.session && !result.session.hasWebAccess) {
        return router.createUrlTree([AUTH_ROUTE_PATH.NO_ACCESS]);
      }

      return true;
    }),
  );
};
